<template>
  <div>
    <Header></Header>
    <main class="main-content">
      <HeroSection />
      <div class="horizontal-layout">
        <ExperienceDescription />
        <ExperienceSection />
      </div>
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HeroSection from "@/components/HeroSection.vue";
import ExperienceDescription from "@/components/ExperienceDescription.vue";
import ExperienceSection from "@/components/ExperienceSection.vue";

export default {
  components: {
    Header,
    HeroSection,
    ExperienceDescription,
    ExperienceSection,
  },
};
</script>

<style scoped>
/* Espaçamento uniforme para compensar o Header */
.main-content {
  max-width: 1200px; /* Padroniza a largura máxima */
  margin: 0 auto; /* Centraliza o conteúdo */
  padding: 20px;
}

/* Layout horizontal */
.horizontal-layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 32px;
}

.horizontal-layout > * {
  flex: 1;
}

.horizontal-layout > :first-child {
  flex: 0.6;
}

.horizontal-layout > :last-child {
  flex: 0.4;
}

/* Responsividade */
@media (max-width: 768px) {
  .horizontal-layout {
    flex-direction: column;
    gap: 24px;
  }
}
</style>
